/** @jsx jsx */
import React from "react";
import { graphql } from "gatsby";
import { jsx, Container, Box, Heading } from "theme-ui";
import ContentfulRichText from "../../shared/ContentfulRichText";
import Action from "../../shared/Action";
import "./indexedContentSection.css";

export const query = graphql`
  fragment ContentfulIndexedContentSectionFragment on ContentfulIndexedContentSection {
    internalName
    index {
        label
        link
    }
    button {
      classnameForAnalytics
      actionEvent
      fullWidth
      icon
      iconSize
      id
      style
      label
      url
      form {
          ...FormFragment
      }
      hubspotForm {
          formId
          portalId
          region
      }
      
    }
    content {
      raw
    }
  }
`;

const getContents = (index) => {
  return index.map((pageIndex, index) => <div className="index-item"><a href={"#"+pageIndex.link}>{(index+1) + ". " + pageIndex.label}</a></div>)
}

const IndexedContent = ({ sectionContent }) => {
  const { index, content, button } = sectionContent;
  return (
    <Box className="index-content-box">
      <Box className="indexed-empty-container"  sx={{flex: 1, backgroundColor: "#F4F4F7"}}></Box>
      <Box className="index-page-section">
        <Box sx={{ display: "flex", flexDirection: 'column', alignItems: "flex-end" }}>
          <Box sx={{width: "250px"}}>
            <Heading as="h6" sx={{ color: "#404041", fontWeight: "bold" }}>Table of Contents</Heading>
            <Box sx={{mt: "20px"}}>
              { getContents(index) }
            </Box>
          </Box>
          {button && (
                <Box sx={{
                    display: 'flex',
                    mb: 4, //margin bottom
                    mt: 2, //margin top
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
                    className="hero-action-item-container">
                    <Action
                        {...button}
                    />
                </Box>
            )}
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100px" }}>

        </Box>
      </Box>
      <Box className="content-page-section">
        <ContentfulRichText richText={content} />
      </Box>
      <Box className="indexed-empty-container" sx={{flex: 1}}></Box>
    </Box>

  );
};

export default IndexedContent;
